import HelpIcon from '@mui/icons-material/Help';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { urls } from 'src/urls';

function HeaderButtons() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box display="flex">
      <Box sx={{ display: { xs: 'none', md: 'inline' } }}>
        <Tooltip title={t('Help & documentation')} arrow>
          <IconButton
            href={urls.helpCenter}
            color="secondary"
            size="small"
            sx={{
              color: theme.palette.secondary.light
            }}
          >
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default HeaderButtons;
